require('./mortgageRequestPreapprovalPdf.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

//commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer')
const { FormattedText } = require('core/i18n').i18n;

// @ constant
const {
    PDF_LETTER_MODAL_HEIGHT,
    PDF_LETTER_NORMAL_HEIGHT,
    PDF_LETTER_MODAL_SCALE,
    PDF_LETTER_NORMAL_SCALE
} = require('constants/mortgageRequestManager')
//@ utilities
const {
    recordLink,
    EVENT_INTERACTION_MORTGAGE_REQUEST,
    EVENT_ACTION_DOWNLOAD_LETTER,
} = require('utilities/tagging');

class MortgageRequestPreapprovalPdf extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numPages: null,
            pageNumber: 1,
            showModal: false,
        }
        this.handleOnShowModal = this.handleOnShowModal.bind(this);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
    }

    handleDownloadPdf() {
        const { pdfBase64, contentType, fileName } = this.props;
        const pdf = `data:${contentType};base64,${pdfBase64}`
        downloadAsFile(base64ToBlob(pdf), contentType, `${fileName}.${getExtension(contentType)}`);

        recordLink(EVENT_INTERACTION_MORTGAGE_REQUEST, EVENT_ACTION_DOWNLOAD_LETTER);
    }

    handleOnShowModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    buildViewer(isModal) {
        const { pdfBase64, contentType } = this.props;
        const onDownload = isModal ? null : this.handleDownloadPdf;
        const pdfFile = `data:${contentType};base64,${pdfBase64}`;
        const viewerHeight = isModal ? PDF_LETTER_MODAL_HEIGHT : PDF_LETTER_NORMAL_HEIGHT;
        const onFullScreen = isModal ? null : this.handleOnShowModal;
        const scale = isModal ? PDF_LETTER_MODAL_SCALE : PDF_LETTER_NORMAL_SCALE;
        const showPagination = isModal ? false : true;
        const showPageShadow = isModal ? false : true;

        let content;

        if (pdfBase64) {
            content = (
                <OKPdfViewer
                    onDownload={onDownload}
                    pdfFile={pdfFile}
                    viewerHeight={viewerHeight}
                    onFullScreen={onFullScreen}
                    scale={scale}
                    showPagination={showPagination}
                    showPageShadow={showPageShadow}
                    isModal={isModal}
                />
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }

    render() {
        const { isClientWithoutAccounts } = this.props;
        const viewer = this.buildViewer();
        const modalViewer = this.buildViewer(true);
        const titleCard = isClientWithoutAccounts ? "mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_RNCmanagerWelcome" : "mortgageRequestManagerDocuments-mortgageRequestManagerDocuments_managerWelcome";

        return (
            <ContentBox>
                <FormattedText
                    value={titleCard}
                    className="preapproval-pdf-content__title"
                />
                <OKModal
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleOnShowModal}
                    content={modalViewer}
                    size="no-width"
                />
                <div className="preapproval-pdf-content">
                    {viewer}
                </div>
            </ContentBox>
        );
    }

}

MortgageRequestPreapprovalPdf.propTypes = {
    pdfBase64: PropTypes.string,
    contentType: PropTypes.string,
    fileName: PropTypes.string,
    isClientWithoutAccounts: PropTypes.bool,
};

module.exports.MortgageRequestPreapprovalPdf = MortgageRequestPreapprovalPdf;
